<div class="row mt-3">
    <app-loader *ngIf="showLoader"></app-loader>
    <div class="col" *ngIf="modelDescription">
        <div class="field mb-3">
            <label>Model:</label>
            <p class="pt-2">{{ modelDescription }}</p>
        </div>
    </div>
    <div class="col" *ngIf="serialNumber">
        <div class="field mb-3">
            <label>Serial Number:</label>
            <p class="pt-2">{{ serialNumber }}</p>
        </div>
    </div>
    <div class="col">
        <div class="field mb-3">
            <label>Warranty:</label>
            <ng-container *ngIf="warrantyInfo">
                <div class="text-white {{ desc.class }} ps-2 bg-coverage-gradient" *ngFor="let desc of warrantyInfo">
                    <div *ngIf="desc.costType === 'No coverage'">
                        <span>{{desc.costType}}</span>
                    </div>
                    <div *ngIf="desc.costType !== 'No coverage'">
                        <span class="warranty-cost-type">  {{ desc.costType }}</span> :
                        <span class="warranty-percentage-coverage"> {{ desc.percentageCoverage }}% </span> -
                        <span class="warranty-effective-date">{{ desc.effectiveDate | date }} </span>
                        <span class="warranty-expiry-date"> to {{ desc.expiryDate | date }} </span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="col">
        <div class="field mb-3">
            <label>Contract:</label>
            <ng-container *ngIf="contractInfo">
                <div class="text-white {{ desc.class }} ps-2 bg-coverage-gradient" *ngFor="let desc of contractInfo">
                    <span class="contract-cost-type"> {{ desc.costType }}</span>
                    <span class="contract-percentage-coverage" *ngIf="desc.costType !== 'No coverage'">:  {{ desc.percentageCoverage }}% -</span>
                    <span class="contract-effective-date" *ngIf="desc.costType !== 'No coverage'"> {{ desc.effectiveDate | date : 'd MMM, y'}} |</span>
                    <span class="contract-expiry-date" *ngIf="desc.costType !== 'No coverage'"> {{ desc.expiryDate | date : 'd MMM, y'}} </span>
                </div>
            </ng-container>

        </div>
    </div>
    <div class="col">
        <div class="field mb-3">
            <div class="text-start"><label class="fw-bold">Approved Amount:</label>
                <span class="ms-3">{{ data.approvedAmount | currency : customerCurrency}}</span>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header d-flex ps-0" data-bs-toggle="collapse" href="#collapseAssignmentsTransactions">
                <a class="card-link flex-fill">Assignments/Transactions</a>
                <i class="fas fa-chevron-up"></i>
            </div>
            <div id="collapseAssignmentsTransactions" class="collapse show">
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-12">
                            <ejs-grid
                                id="assignmentsGrid"
                                #assignmentsGrid
                                *ngIf="ddlFetched"
                                [dataSource]="assignments"
                                [height]="80"
                                [rowHeight]="30"
                                [allowFiltering]="true"
                                [allowExcelExport]="true"
                                [allowSorting]="true"
                                [allowResizing]="true"
                                [allowReordering]="true"
                                [showColumnChooser]="true"
                                [editSettings]="{ allowEditing: isEditable, allowAdding: true, allowDeleting: true, mode: 'Normal'}"
                                [toolbar]="$safeNavigationMigration(assignmentGrid?.toolbar)"
                                [filterSettings]="{ type: 'Menu' }"
                                [query]="query"
                                (created)="onAssignmentsGridCreated($event)"
                                (rowSelected)="onAssignmentSelected($event)"
                                (rowDataBound)="onRowDataBound($event)"
                                (toolbarClick)="onAssignmentsToolbarClick($event, assignmentsGrid)"
                                (commandClick)="onAssignmentCommandClick($event)"
                                (actionBegin)="assignmentActionBegin($event)"
                                (actionComplete)="onAssignmentGridActionComplete($event, assignmentsGrid)"
                                (excelQueryCellInfo)="onExcelQueryCellInfo($event)"
                            >
                                <e-columns>
                                    <e-column
                                        *ngFor="let column of assignmentGrid?.columns;"
                                        [field]="column.field"
                                        [headerText]="column.headerText"
                                        [clipMode]="'EllipsisWithTooltip'"
                                        [type]="column.type"
                                        [width]="column.width"
                                        [edit]="column.edit"
                                        [editType]="column.editType"
                                        [foreignKeyValue]="column.foreignKeyValue"
                                        [foreignKeyField]="column.foreignKeyField"
                                        [dataSource]="column.dataSource"
                                        [isPrimaryKey]="column.isPrimaryKey || false"
                                        [format]="column.format ? column.format : null"
                                        [textAlign]="column.textAlign"
                                        [visible]="column.visible"
                                        [validationRules]="column.validationRules"
                                        [showInColumnChooser]="column.showInColumnChooser ?? true"
                                        [allowEditing]="column.allowEditing"
                                        [filter]="column.filter ? column.filter : { type: 'Menu'}"
                                        [commands]="column?.commands ? column.commands : null"
                                        [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                                        <ng-template *ngIf="column.field === 'serviceOrderId'" #template let-data>
                                            <a href="javascript:" (click)="onConsignmentClick(data.serviceOrderId)">{{data.serviceOrderId}}</a>
                                        </ng-template>
                                        <ng-template *ngIf="column.headerText === 'Reference Activity'" #headerTemplate let-data>
                                            <div>
                                                Reference Activity <span class="required-asterik">*</span>
                                            </div>
                                        </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                        <div class="col-12 mt-3">
                            <ejs-grid
                                #assignmentDetailsGrid
                                [id]="transactionGridName"
                                *ngIf="ddlFetched"
                                [height]="180"
                                [rowHeight]="30"
                                [dataSource]="assignmentDetails"
                                [allowFiltering]="true"
                                [allowExcelExport]="true"
                                [allowSorting]="true"
                                [allowReordering]="true"
                                [showColumnChooser]="true"
                                [enablePersistence]="false"
                                [allowResizing]="true"
                                [editSettings]="{ allowEditing: isEditable, allowAdding: true, allowDeleting: true, mode: 'Normal' }"
                                [toolbar]="assignmentDetailGrid.toolbar"
                                [filterSettings]="{ type: 'Menu' }"
                                [query]="query"
                                (headerCellInfo)="headerCellInfo($event)"
                                (queryCellInfo)="queryCellInfo($event)"
                                (created)="onTransactionsGridCreated($event)"
                                (rowSelected)="onTransactionSelected($event)"
                                (rowDataBound)="onTransactionRowDataBound($event)"
                                (toolbarClick)="onAssignmentDetailsToolbarClick($event, assignmentDetailsGrid)"
                                (commandClick)="onAssignmentDetailsCommandClick($event)"
                                (actionBegin)="onAssignmentDetailsActionBegin($event)"
                                (actionComplete)="onTransactionGridActionComplete($event, assignmentDetailsGrid)"
                                (excelQueryCellInfo)="onExcelQueryCellInfo($event)"
                            >
                                <e-columns>
                                    <e-column
                                        *ngFor="let column of assignmentDetailGrid.columns;"
                                        [field]="column.field"
                                        [headerText]="column.headerText"
                                        [clipMode]="'EllipsisWithTooltip'"
                                        [type]="column.type"
                                        [width]="column.width"
                                        [edit]="column.edit"
                                        [editType]="column.editType"
                                        [foreignKeyValue]="column.foreignKeyValue"
                                        [foreignKeyField]="column.foreignKeyField"
                                        [dataSource]="column.dataSource"
                                        [isPrimaryKey]="column.isPrimaryKey || false"
                                        [format]="column.format ? column.format : null"
                                        [textAlign]="column.textAlign"
                                        [visible]="column.visible"
                                        [validationRules]="column.validationRules"
                                        [showInColumnChooser]="column.showInColumnChooser ?? true"
                                        [filter]="column.filter ? column.filter : { type: 'Menu'}"
                                        [commands]="column?.commands ? column.commands : null"
                                        [allowEditing]="column.allowEditing"
                                        [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                                        <ng-template *ngIf="column.field === 'serviceOrderId'" #template let-data>
                                            <a href="javascript:" (click)="onConsignmentClick(data.serviceOrderId)">{{data.serviceOrderId}}</a>
                                        </ng-template>
                                            <ng-template *ngIf="column.headerText === 'Reference Activity'" #headerTemplate let-data>
                                                <div>
                                                    Reference Activity <span class="required-asterik">*</span>
                                                </div>
                                            </ng-template>
                                            <ng-template *ngIf="column.headerText === 'Quantity'" #headerTemplate let-data>
                                                <div>
                                                    Quantity <span class="required-asterik">*</span>
                                                </div>
                                            </ng-template>
                                            <ng-template *ngIf="column.headerText === 'Price'" #headerTemplate let-data>
                                                <div>
                                                    Price <span class="required-asterik">*</span>
                                                </div>
                                            </ng-template>
                                            <ng-template *ngIf="column.field === 'itemCode'" #template let-data>
                                                <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemCode}}</a>
                                            </ng-template>
                                            <ng-template *ngIf="column.field === 'itemDescription'" #template let-data>
                                                <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemDescription}}</a>
                                            </ng-template>
                                            <ng-template *ngIf="column.field== 'itemCode'" #headerTemplate let-data>
                                                <div>
                                                    Item <span class="required-asterik">*</span>
                                                </div>
                                            </ng-template>
                                    </e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header d-flex ps-0" data-bs-toggle="collapse" href="#collapseDetails">
                <a class="card-link flex-fill">Details</a>
                <i class="fas fa-chevron-up"></i>
            </div>
            <div id="collapseDetails" class="collapse show">
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-3">
                            <div class="field mb-1 p-2" style="background-color: #a5d2fe;">
                                <label class="details-amount">My Claim Amount ({{ customerCurrency }}):<b class="fw-bold"> {{ data.totalClaimAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3 pt-2">
                            <div class="field mb-1">
                                <label class="details-amount">Discount Amount ({{customerCurrency}}):<b class="fw-bold"> {{ data.discountAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3 pt-2">
                            <div class="field mb-1">
                                <label class="details-amount">Warranty Coverage ({{customerCurrency}}):<b class="fw-bold"> {{ data.warrantyCoverage | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3 pt-2">
                            <div class="field mb-1">
                                <label class="details-amount">Contract Coverage ({{customerCurrency}}):<b class="fw-bold"> {{ data.contractCoverage | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="details-amount">Sales Amount ({{customerCurrency}}):<b class="fw-bold"> {{ data.salesAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="details-amount">Total Amount ({{ customerCurrency }}):<b class="fw-bold"> {{ data.totalAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="details-amount">Tax ({{ customerCurrency }}):<b class="fw-bold"> {{ data.tax | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="fw-bold details-amount">Invoice Amount ({{ customerCurrency }}):<b class="fw-bold"> {{ data.invoiceAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-isc-assignments-popup
  *ngIf="showAssignmentsPopup"
  [data]="selectedAssignment"
  [assignments]="assignments"
  [assignmentDetails]="assignmentDetails"
  [equipmentInfo]="equipmentInfoData"
  [soCreatedDate]="data.soCreatedDate"
  [referenceActivities]="referenceActivities"
  [reportedProblems]="reportedProblems"
  [solutions]="solutions"
  [priorities]="priorities"
  (onClose)="selectedAssignment = null; showAssignmentsPopup = false;"
  (onSave)="saveAssignment($event)"
></app-isc-assignments-popup>

<app-isc-assignment-details-popup
  *ngIf="showAssignmentDetailsPopup"
  [costTypes]="costTypes"
  [taxRates]="taxRates"
  [checkinTime]="checkinTime"
  [technicianId]="$safeNavigationMigration(data?.technicianId)"
  [assignments]="assignments"
  [assignmentDetails]="assignmentDetails"
  [loadedAssignmentItemDetails]="loadedAssignmentItemDetails"
  [equipmentInfo]="equipmentInfoData"
  [soCreatedDate]="data.soCreatedDate"
  [serviceOrderId]="data.serviceOrderId"
  [data]="selectedAssignmentDetail"
  [units]="units"
  [returnReasons]="returnReasons"
  [distanceZone]="distanceZone"
  [configurationId]="configurationId"
  [customerCode]="data.customerCode"
  (onClose)="showAssignmentDetailsPopup = false; selectedAssignmentDetail = null;"
  (onSave)="saveAssignmentDetail($event)"
></app-isc-assignment-details-popup>

<ng-template #columnChooserAssignments>
  <app-column-chooser
    [grid]="assignmentsGrid"
  ></app-column-chooser>
</ng-template>

<ng-template #columnChooserAssignmentDetails>
  <app-column-chooser
    [grid]="assignmentDetailsGrid"
  ></app-column-chooser>
</ng-template>

<ng-template #assignmentTemplate let-data>
  <div class="e-list-item" [title]="data.description">{{data.description}}</div>
</ng-template>

<ng-template #cartWithCounter>
  <i class="fa fa-shopping-cart" aria-hidden="true"></i>
  <span class="badge-red">
    <span class="e-badge e-badge-overlap e-badge-notification e-badge-circle count-position">{{cartCount}}</span>
  </span>
</ng-template>

<app-items-advanced-search
  *ngIf="showItemAdvancedSearchPopup"
  [technicianId]="$safeNavigationMigration(data?.technicianId)"
  [serviceItemGroup]="serviceItemGroup"
  (onClose)="onItemAdvancedSearchPopupClose($event)"
></app-items-advanced-search>

<app-cart-checkout-popup
  *ngIf="showCartCheckoutPopup"
  [recievedItems]="fromExecutionTab"
  [serviceOrderId]="data.serviceOrderId"
  [onsiteAddress]="onsiteAddressForPurchaseOrder"
  (onClose)="showCartCheckoutPopup = false;"
></app-cart-checkout-popup>

<app-parts-catalog-popup
  *ngIf="showPartsCatalogPopup"
  [serviceOrderId]="data.serviceOrderId"
  [onsiteAddress]="onsiteAddressForPurchaseOrder"
  [currency]="USER.orderCurrency"
  (onClose)="showPartsCatalogPopup = false;"
></app-parts-catalog-popup>
